<div class="flex flex-col bg-white overflow-hidden h-full min-h-0" [@rise]>

  <div class="flex-1 min-h-0 overflow-y-auto thin-scrollbar">
    <div class="flex flex-col md:flex-row md:items-start">
    <aside class="relative shrink-0 w-full md:w-[360px] bg-[#0f3d3b] px-5 py-[22px] md:p-10 md:pb-9 flex flex-col gap-[14px] md:gap-6">
      <div aria-hidden="true" class="hidden md:block absolute top-[18px] -right-5 w-40 h-[120px] pointer-events-none z-0"
           style="background-image: radial-gradient(circle, rgba(102,229,178,0.18) 1px, transparent 1.5px); background-size: 12px 12px;"></div>
      <div aria-hidden="true" class="hidden md:block absolute -bottom-20 -left-20 size-[260px] rounded-full pointer-events-none z-0 blur-[2px]"
           style="background: radial-gradient(circle, rgba(102,229,178,0.18) 0%, transparent 70%);"></div>
      <div aria-hidden="true" class="hidden md:block absolute -bottom-10 -left-10 size-[180px] rounded-full pointer-events-none z-0 border border-[rgba(102,229,178,0.15)] blur-[2px]"></div>

      <div class="relative z-[1] flex flex-col gap-[14px] md:gap-6">
        <button type="button"
                class="absolute md:hidden top-[7px] right-[7px] size-7 rounded-full bg-[#f5f7f7] border-none cursor-pointer flex items-center justify-center text-[#6b7d82] text-[11px] font-semibold transition-colors hover:bg-[#e8ebeb] hover:text-[#022d35]"
                (click)="dialogRef.close()">
          <mat-icon svgIcon="close" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-[#6B7D82]"></mat-icon>
        </button>
        @if (enterprisePlan(); as plan) {
          <div class="flex items-start justify-between gap-3">
            <h2 class="!m-0 flex-1 text-white !text-[22px] !font-bold !leading-[1.1]">{{ plan.name }}</h2>
          </div>

          <ul class="list-none m-0 p-0 flex flex-col gap-[10px] md:gap-[14px]">
            <li class="flex items-center md:items-start gap-3">
              <span class="shrink-0 size-5 md:size-[22px] rounded-full bg-[#218c59] text-white flex items-center justify-center leading-none">
                <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-auto max-w-[12px] max-h-[8px] text-inherit mt-[1px]"></mat-icon>
              </span>
              <div class="flex flex-col gap-[2px] flex-1">
                <p class="!m-0 text-white text-[13px] md:text-[16px] font-semibold leading-[1.4]">{{ plan.enabledProviders.length }} AML Providers</p>
              </div>
            </li>
            <li class="flex items-center md:items-start gap-3">
              <span class="shrink-0 size-5 md:size-[22px] rounded-full bg-[#218c59] text-white flex items-center justify-center leading-none">
                <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-auto max-w-[12px] max-h-[8px] text-inherit mt-[1px]"></mat-icon>
              </span>
              <div class="flex flex-col gap-[2px] flex-1">
                <p class="!m-0 text-white text-[13px] md:text-[16px] font-semibold leading-[1.4]">Recovery Fees 7%</p>
              </div>
            </li>
              <li class="flex items-center md:items-start gap-3">
                <span class="shrink-0 size-5 md:size-[22px] rounded-full bg-[#218c59] text-white flex items-center justify-center leading-none">
                  <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-auto max-w-[12px] max-h-[8px] text-inherit mt-[1px]"></mat-icon>
                </span>
                <div class="flex flex-col gap-[2px] flex-1">
                  <p class="!m-0 text-white text-[16px] font-semibold leading-[1.4]">Custom Pricing</p>
                </div>
              </li>
          </ul>
        }

        <div class="hidden md:block h-px w-full bg-white/10"></div>

        <div class="flex flex-col gap-2 md:gap-[10px]">
          <p class="!m-0 text-[#66e5b2] text-[10px] font-bold tracking-[0.6px] md:tracking-[0.8px]">ON THE 30-MIN CALL</p>
          @for (item of agenda; track item.text) {
            <div class="flex items-center gap-3">
              <span class="hidden md:flex shrink-0 size-7 bg-white/[0.04] rounded-lg text-[#66e5b2] text-[14px] font-bold items-center justify-center">{{ item.icon }}</span>
              <span class="md:hidden text-[#66e5b2] font-bold text-base">›</span>
              <p class="!m-0 flex-1 text-white text-[12px] md:text-[13px] font-normal md:font-medium">{{ item.text }}</p>
            </div>
          }
        </div>

        <div class="hidden md:flex gap-2 bg-white/[0.04] border border-white/10 rounded-[12px] p-[14px]">
          @for (stat of stats; track stat.label) {
            <div class="flex-1 flex flex-col gap-[2px]">
              <p class="!m-0 text-white text-[16px] font-bold">{{ stat.value }}</p>
              <p class="!m-0 text-[#a1c4c7] text-[10px] tracking-[0.4px]">{{ stat.label }}</p>
            </div>
          }
        </div>

        <div class="hidden md:flex flex-col gap-2">
          <p class="!m-0 text-[#66e5b2] text-[36px] font-bold leading-[24px]">“</p>
          <p class="!m-0 text-white text-[13px] font-medium leading-[1.4]">Saved us 60% vs our previous AML provider — onboarded in a week.</p>
          <p class="!m-0 text-[#a1c4c7] text-[11px]">— Head of Compliance, Tier-1 exchange</p>
        </div>
      </div>
    </aside>

    <section class="flex-1 min-w-0 flex flex-col bg-[#f7fafa] md:bg-white p-0 md:p-5 relative">
      <button type="button"
              class="hidden md:flex absolute top-[7px] right-[7px] size-7 rounded-full bg-[#f5f7f7] border-none cursor-pointer items-center justify-center text-[#6b7d82] text-[11px] font-semibold transition-colors hover:bg-[#e8ebeb] hover:text-[#022d35] z-[1]"
              (click)="dialogRef.close()">
        <mat-icon svgIcon="close" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-[#022D35]"></mat-icon>
      </button>

      <div
        #calendlyHost
        class="calendly-host w-full min-w-0 md:rounded-[12px] bg-[#f7fafa]">
      </div>
    </section>
    </div>
  </div>

  <footer class="shrink-0 flex md:hidden justify-between items-start px-5 py-[14px] bg-white border-t border-[#f0f3f3]">
    @for (stat of stats; track stat.label) {
      <div class="flex flex-col gap-[2px]">
        <p class="!m-0 text-[#022d35] text-[14px] font-bold">{{ stat.value }}</p>
        <p class="!m-0 text-[#6b7d82] text-[10px] tracking-[0.4px]">{{ stat.label }}</p>
      </div>
    }
  </footer>
</div>
